module.exports = __webpack_public_path__ + "stone-bg.png?9c1db071a86f3b48d38a18360f129c04";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stone-bg.png
// module id = 169
// module chunks = 0